<script setup lang="ts">
defineProps({
  isActive: {
    type: Boolean,
    default: true,
  },
  isWarning: {
    type: Boolean,
    default: false,
  },
  isError: {
    type: Boolean,
    default: false,
  },
  isLight: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div
    class="v-scroll-item"
    :class="{
      'v-scroll-item_disconnect': !isActive,
      'v-scroll-item_warning': isWarning,
      'v-scroll-item_error': isError,
      'v-scroll-item_light': isLight,
    }"
  >
    <div class="v-scroll-item__header">
      <slot name="header" />
    </div>

    <div class="v-scroll-item__body">
      <slot name="body" />
    </div>
  </div>
</template>
